import React from 'react';

const FooterSection = () => {
    return (
        <div className="text-white bg-gray-900 py-16">
            <div className="container ">
                <h3 className="text-3xl">Maintaining the Collection</h3>

                <div className="h-divider"></div>

                <p className="mt-6">
                    The layers and maps made available in the Esri National
                    Geospatial Open Data Collection are sourced directly from
                    U.S. government agency ArcGIS Online services. Where
                    possible, these resources are cached and rehost on ArcGIS
                    Online from federally maintained services and checked for
                    updates every weekend. In all cases, users can be assured
                    that they are getting the most performant services possible
                    and that the data quality is the same as the source.
                </p>

                <p className="mt-6">
                    For questions, please contact{' '}
                    <a
                        className="text-blue-200"
                        href="mailto:ArcGIScomNationalMaps@esri.com"
                    >
                        ArcGIScomNationalMaps@esri.com
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};

export default FooterSection;
